<style>
.bet-table-header{
    border-bottom: 0px solid #c7c8ca;
    border-top: 0px solid #c7c8ca;
    padding: 0px 0;}
    
    .odd-box{
        border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    float: left;
    font-size: 14px;
    line-height: 13px !important;
    padding: 5px 0;
    width: 49% !important;
        margin-right: 0.5%;
    }
    .bet-table-row
    {padding: 2px 1px;}
    
   
    .bet-nation-game-name span {
        color: #000 !important;
    font-family: Roboto Condensed, sans-serif !important;
    font-weight: 700 !important;
            cursor: pointer;
    display: inline-block;
    font-weight: 700;
    line-height: 17px;
    max-width: 750px !important;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
}
    }
    
    .over-wrap {
    overflow: hidden;
    overflow-y: auto;
}
/* Hide on mobile (less than 768px) */
.goneonmobile {
  display: none;
}

/* Show on desktop (768px and up) */
@media (min-width: 768px) {
  .goneonmobile {
    display: block;
      

  }
  .mbmb1oa{
      width:84%;
  }
}

</style>

<div style="display:flex;">
    
                    <div class="col-left col-left-login goneonmobile" style="width: 16%; background-color: #FFF;" id="sidebar"><div class="sub_path over-wrap">
                <ul class="list-unstyled components">
  <p style=" background-color: #072c50;
    color: #fff;     margin: 0;
    padding: 2px 7px;
    text-transform: capitalize;">Popular <i class="fa fa-close pt-1 icon-toggle-right mobile-menu float-right"></i></p>
<style>
element.style {
    text-transform: capitalize;
}
#sidebar ul li a {
    border-bottom: 1px solid #e8e8e8;
    color: #000;
}
#sidebar ul li a {
    align-items: center;
    display: flex
;
    padding: 8px 10px;
}
#sidebar ul li a, #sidebar ul p {
    font-family: Roboto Condensed, sans-serif;
    font-size: 14px;
    font-weight: 700;
}
a[data-toggle=collapse] {
    position: relative;
}
a:not([href]), a:not([href]):hover {
    color: inherit;
    text-decoration: none;
}
.dropdown-toggle {
    white-space: nowrap;
}
a, a:active, a:focus, a:hover {
    outline: none;
    text-decoration: none;
}
a {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}
a {
    background-color: transparent;
    color: #007bff;
}
#sidebar ul li a:hover {
    background-color: #f8bd23;
    color: #000;
}
.list-unstyled.components .sports-icon {
    background-position: 0 -900px;
    background-repeat: no-repeat;
    background-size: 28px auto;
    display: inline-block;
    height: 24px;
    margin-right: 5px;
    overflow: hidden;
    vertical-align: bottom;
    width: 28px;
    background-image: url(https://images.staticcontent.io/casino/banner/images/sports-icons.png);
}
#sidebar ul li dropdown-toggle:hover {
    background-color: #f8bd23;
}

.dropdown-toggle::after {
        display: block;
    font-size: 16px;
    position: absolute;
   
        left: 14%;

    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    
    #sidetree {
    background: #e1e4ef;
    font-size: 12px;
    padding: 2px 5px;
}
}
</style>
 

  <li>
    <a aria-expanded="true"><span class="sports-icon inplayside" style=" background-position: 0 -1527px;"></span> In-Play</a>
  </li>

  <li>
    <a href="/ipl"><span class="sports-icon iplwinnerside" style="background-position: 0 -1775px;"></span> IPL 2025</a>
  </li>

  <li>
    <a class="dropdown-toggle"><span class="sports-icon cricketside" style="background-position: 0 -326px;"></span> Cricket</a>
    <div id="sidetree" style="display: none;">
      <ul>
        <li class="treeview">
          <span class="treeviewnode">Indian Premier League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Royal Challengers Bengaluru v Rajasthan Royals</span></li>
            <li class="treeview"><span class="treeviewnode">Kolkata Knight Riders v Punjab Kings</span></li>
            <li class="treeview"><span class="treeviewnode">Chennai Super Kings v Sunrisers Hyderabad</span></li>
            <li class="treeview"><span class="treeviewnode">Mumbai Indians v Lucknow Super Giants</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Womens One Day Internationals</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Sri Lanka Women v India Women</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">International Twenty20 Matches</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Canada v USA</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Pakistan Super League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Quetta Gladiators v Karachi Kings</span></li>
            <li class="treeview"><span class="treeviewnode">Lahore Qalandars v Peshawar Zalmi</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Test Matches</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Bangladesh v Zimbabwe</span></li>
          </ul>
        </li>
      </ul>
    </div>
  </li>

  <li>
    <a class="dropdown-toggle"><span class="sports-icon soccerside" style="background-position: 0 -1026px;"></span> Soccer</a>
    <div id="sidetree" style="display: none;">
      <ul>
        <li class="treeview">
          <span class="treeviewnode">Spanish La Liga</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Getafe v Real Madrid</span></li>
            <li class="treeview"><span class="treeviewnode">Alaves v Real Sociedad</span></li>
            <li class="treeview"><span class="treeviewnode">Leganes v Girona</span></li>
            <li class="treeview"><span class="treeviewnode">Osasuna v Sevilla</span></li>
            <li class="treeview"><span class="treeviewnode">Atletico Madrid v Rayo Vallecano</span></li>
            <li class="treeview"><span class="treeviewnode">Betis v Valladolid</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Dutch Eredivisie</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Az Alkmaar v NAC Breda</span></li>
            <li class="treeview"><span class="treeviewnode">FC Twente v PSV</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">English Premier League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Arsenal v Crystal Palace</span></li>
          </ul>
        </li>
      </ul>
    </div>
  </li>
 
<li>
    <a href="/ipl"><span class="sports-icon iplwinnerside" style="background-position: 0 -1742px;"></span>Indian Poker II</a>
</li>
<li>
    <a href="/ipl"><span class="" style="    height: 18px;
    margin-left: 0;
    margin-right: 5px;
    width: 18px; background-position: 0 -1775px;"><img style="    height: 18px;
    margin-left: 0;
    margin-right: 5px;
    width: 18px;" class="ball-images-tab" src="https://images.staticcontent.io/casino/banner/images/aviator-icon.svg" alt=""></span> Aviator</a>
</li>

<li 
    >
  
   <a href="./dashboard/livecasino?vendorId=AWC"><span class="sports-icon iplwinnerside" style="background-position: 0 -863px;"></span>
      AE Sexy
    </a>
</li>
<li *ngFor="let vendor of vendors"
    >
  
   <a href="./dashboard/livecasino?vendorId={{ vendor.providerCode }}"><span class="sports-icon iplwinnerside" style="background-position: 0 -863px;"></span>
      {{ vendor.providerName }}
    </a>

   

  <!--<ul class="dropdown-menu" style="background-color: #edf0fa; border-radius: 5px; padding: 10px; min-width: 240px;">-->
  <!--  <li *ngFor="let category of categories" style="display: flex; align-items: center; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #ddd;">-->
      
  <!--    <a class="dropdown-item" href="javascript:void(0);" -->
  <!--       (click)="onSelectCategory(category); onVendorChange(vendor.providerCode)"-->
  <!--       style="text-decoration: none; color: #000; padding-left: 10px; border-left: 2px solid #007bff; flex-grow: 1;">-->
  <!--      {{ category }}-->
  <!--    </a>-->

  <!--    <span style="display: inline-block; background-color: #fff; border: 1px solid #ccc; padding: 0px 5px; font-weight: bold; font-size: 14px; margin-left: 10px;">+</span>-->
  <!--  </li>-->
  <!--</ul>-->
</li>



</ul>
</div>
</div>

<div class="content-wrapper mbmb1oa" style="overflow-y: auto; padding: 5px;" >
  <div class="pt-0">
    <div class="" id="cricket">
      <div class="card-body">
        <div class="bet-table">
          <div class="bet-table-header">
            <div class="bet-nation-name main-heading"><b>Tennis</b></div>
            <div class="bet-nation-odd mobile-hide main-heading"><b>1</b></div>
            <div class="bet-nation-odd mobile-hide main-heading"><b>X</b></div>
            <div class="bet-nation-odd mobile-hide main-heading"><b>2</b></div>
          </div>
          <div class="bet-table-body">
            <!-- active markets -->
            <div class="bet-table-row" *ngFor="let tennisMarket of tennisMarkets"
              (click)="openTennisDetails(tennisMarket.event_id)">
              <div class="bet-nation-name"><a class="bet-nation-game-name"><span>
                    {{ tennisMarket.event_name.split(" / ")[0] }}</span><span
                    class="d-none d-md-inline-block">&nbsp;/&nbsp;</span><span>{{
                    tennisMarket.start_time | date : "dd/MM/YYYY H:mm" : "IST"
                    }}</span></a>
                <div class="game-icons">
                  <div class="game-icon"><span class="active"></span></div>
                  <div class="game-icon"><i class="fas fa-tv icon-tv"></i></div>
                  <div class="game-icon"><img src="/assets/icons/ic_fancy.png"></div>
                  <div class="game-icon"><img src="/assets/icons/ic_bm.png"></div>
                  <div class="game-icon"></div>
                </div>
              </div>
              <div class="bet-nation-odd d-xl-none mobile-hide"><b>1</b></div>
              <div class="bet-nation-odd d-xl-none mobile-hide"><b>X</b></div>
              <div class="bet-nation-odd d-xl-none mobile-hide"><b>2</b></div>
              <div class="bet-nation-odd">
                <div class="back odd-box"><span class="bet-odd"><b>{{ tennisMarket.back0_price }}</b></span></div>
                <div class="lay odd-box"><span class="bet-odd"><b>{{ tennisMarket.lay0_price }}</b></span></div>
              </div>
              <div class="bet-nation-odd">
                <div class="back odd-box" *ngIf="tennisMarket.runner3 != null; else drawFalse"><span
                    class="bet-odd"><b>{{
                      tennisMarket.back2_price }}</b></span>
                </div>
                <ng-template #drawFalse>
                  <div class="back odd-box"><span class="bet-odd"><b>--</b></span></div>
                </ng-template>
                <div class="lay odd-box" *ngIf="tennisMarket.runner3 != null; else drawFalse1"><span
                    class="bet-odd"><b>{{
                      tennisMarket.lay2_price }}</b></span></div>
                <ng-template #drawFalse1>
                  <div class="lay odd-box"><span class="bet-odd"><b>--</b></span></div>
                </ng-template>
              </div>
              <div class="bet-nation-odd">
                <div class="back odd-box"><span class="bet-odd"><b>{{ tennisMarket.back1_price }}</b></span></div>
                <div class="lay odd-box"><span class="bet-odd"><b>{{ tennisMarket.lay1_price }}</b></span></div>
              </div>
            </div>

            <!-- inactivemarkets -->
            <div class="bet-table-row" *ngFor="let market of inActiveTennisMarkets"
              (click)="openTennisDetails(market.event_id)">
              <div class="bet-nation-name"><a class="bet-nation-game-name"><span>
                    {{ market.runner1 }} v {{ market.runner2 }}</span><span
                    class="d-none d-md-inline-block">&nbsp;/&nbsp;</span><span>{{
                    market.start_time | date : "dd/MM/YYYY H:mm" : "IST" }}</span></a>
                <div class="game-icons">
                  <!-- <div class="game-icon"><span class="active"></span></div> -->
                  <div class="game-icon"><i class="fas fa-tv icon-tv"></i></div>
                  <div class="game-icon"><img src="/assets/icons/ic_fancy.png"></div>
                  <div class="game-icon"><img src="/assets/icons/ic_bm.png"></div>
                  <div class="game-icon"></div>
                </div>
              </div>
              <div class="bet-nation-odd d-xl-none mobile-hide"><b>1</b></div>
              <div class="bet-nation-odd d-xl-none mobile-hide"><b>X</b></div>
              <div class="bet-nation-odd d-xl-none mobile-hide"><b>2</b></div>
              <div class="bet-nation-odd">
                <div class="back odd-box"><span class="bet-odd"><b>{{ market.back0_price }}</b></span></div>
                <div class="lay odd-box"><span class="bet-odd"><b>{{ market.lay0_price }}</b></span></div>
              </div>
              <div class="bet-nation-odd">
                <div class="back odd-box" *ngIf="market.runner3 != null; else drawFalse"><span class="bet-odd"><b>{{
                      market.back2_price }}</b></span></div>
                <ng-template #drawFalse>
                  <div class="back odd-box"><span class="bet-odd"><b>--</b></span></div>
                </ng-template>
                <div class="lay odd-box" *ngIf="market.runner3 != null; else drawFalse1"><span class="bet-odd"><b>{{
                      market.lay2_price }}</b></span></div>
                <ng-template #drawFalse1>
                  <div class="lay odd-box"><span class="bet-odd"><b>--</b></span></div>
                </ng-template>
              </div>
              <div class="bet-nation-odd">
                <div class="back odd-box"><span class="bet-odd"><b>{{ market.back1_price }}</b></span></div>
                <div class="lay odd-box"><span class="bet-odd"><b>{{ market.lay1_price }}</b></span></div>
              </div>
            </div>
            <!-- inactivemarkets -->
          </div>
        </div>
      </div>
    </div>

  </div>
</div>